import { mapPagination } from '@/shared/mappers';
import { DataWithPagination, Page } from '@/shared/types';
import { AdminPrivilege } from '../domain/admin-privilege';
import { AdminPrivilegeJson } from '../types/admin-privilege';

export function mapAdminPrivilegePage(
  page: Page<AdminPrivilegeJson>,
): DataWithPagination<AdminPrivilege[]> {
  return {
    items: page.items.map<AdminPrivilege>((item) => ({
      tenant: item.tenant ?? '',
      tenantId: item.tenantId,
      organization: item.organization ?? '',
      organizationId: item.organizationId,
      company: item.company ?? '',
      companyId: item.companyId,
      roleName: item.roleName ?? '',
      roleId: item.roleId ?? 0,
      roleEntity: item.roleEntity,
    })),
    ...mapPagination(page),
  };
}
